'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Badge, Button, type ButtonProps, Icon } from '@repo/ui';
import { Close, Filter } from '@repo/ui/icons';
import { Popover as RadixPopover } from 'radix-ui';
import { type ForwardedRef, forwardRef, use } from 'react';
import { MasterFilterContext } from './MasterFilter';
export interface MasterFilterTriggerProps {
  label?: string;
  size?: ButtonProps['size'];
  className?: string;
  disabled?: boolean;
}
function MasterFilterTriggerInner(t0, ref) {
  const $ = _c(17);
  const {
    label: t1,
    size: t2,
    className,
    disabled
  } = t0;
  const label = t1 === undefined ? "Filter" : t1;
  const size = t2 === undefined ? "sm" : t2;
  const context = use(MasterFilterContext);
  if (!context) {
    throw new Error("MasterFilter.Trigger must be used within a MasterFilter.Provider");
  }
  const {
    meta,
    actions
  } = context;
  let t3;
  if ($[0] !== actions) {
    t3 = function handleClearClick(event) {
      event.stopPropagation();
      actions.clearAll();
    };
    $[0] = actions;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClearClick = t3;
  let t4;
  if ($[2] !== className) {
    t4 = cn("gap-2xs w-fit", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon icon={<Filter />} className="text-secondary-foreground" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== label) {
    t6 = <span>{label}</span>;
    $[5] = label;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== handleClearClick || $[8] !== meta.activeCount) {
    t7 = meta.activeCount > 0 && <><Badge variant="tertiary" size="sm">{meta.activeCount}</Badge><span onClick={handleClearClick} role="button" className={cn("cursor-pointer border-none bg-transparent p-0", "text-secondary-foreground hover:text-foreground")}><Icon icon={<Close />} /></span></>;
    $[7] = handleClearClick;
    $[8] = meta.activeCount;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== disabled || $[11] !== ref || $[12] !== size || $[13] !== t4 || $[14] !== t6 || $[15] !== t7) {
    t8 = <RadixPopover.Trigger asChild={true}><Button ref={ref} variant="ghost" size={size} disabled={disabled} className={t4} data-testid="master-filter-trigger">{t5}{t6}{t7}</Button></RadixPopover.Trigger>;
    $[10] = disabled;
    $[11] = ref;
    $[12] = size;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}
export const MasterFilterTrigger = forwardRef(MasterFilterTriggerInner);
MasterFilterTrigger.displayName = 'MasterFilterTrigger';